import { VHCRecordLogInput } from 'api/generated';
import 'features/shared/styles.css';
import { useCommonUpdateCdkMileageMutation } from 'features/vhc/api/use-common-update-cdk-mileage.mutation';
import { useUpdateVhcRecordsMutation } from 'features/vhc/api/use-update-vhc-records.mutation';
import { FC, useEffect, useState } from 'react';

type Props = {
  id: number;
  onClose: (isReload?: boolean) => void;
  branchId?: number;
  cdkVehicleId?: string;
} & VHCRecordLogInput;

export const ModalForm: FC<Props> = (props) => {
  const [mileage, setMileage] = useState<number | null>();
  const { onClose, id } = props;

  useEffect(() => {
    setMileage(props.mileage);
  }, [props]);
  const { mutate, isLoading } = useUpdateVhcRecordsMutation();
  const { mutate: handleUpdateCdkMileage, isLoading: isLoadingUpdateCdkMileage } = useCommonUpdateCdkMileageMutation();

  const handleSave = () => {
    const { vin } = props;

    if (!vin) {
      mutate({
        id,
        requestBody: { ...props, mileage: mileage }
      });

      onClose(true);
      return;
    }

    Promise.all([
      mutate({
        id,
        requestBody: { ...props, mileage: mileage }
      }),
      handleUpdateCdkMileage({
        vin: vin,
        mileage: mileage!
      })
    ]);

    onClose(true);
  };

  return (
    <div className={`container m-0 p-0`}>
      <div className="row">
        <div className="col-12 pt-3">
          <input
            type="number"
            className="form-control form-control-solid"
            value={mileage ?? ''}
            onChange={(e) => setMileage(Number(e.target.value))}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-start pt-6">
            <div className="d-flex flex-row justify-content-left">
              <button
                type="button"
                className="btn btn-primary me-5"
                disabled={isLoading || !mileage || mileage <= 0}
                onClick={handleSave}
              >
                {!isLoading && !isLoadingUpdateCdkMileage ? (
                  'Save'
                ) : (
                  <span className="indicator-progress" style={{ display: 'block' }}>
                    Please wait... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                )}
              </button>
              <button type="button" onClick={() => onClose()} className="btn btn-light-primary me-5">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
